import React from 'react';
import PropTypes from 'prop-types';
import { restroomsSelected } from './data/utils';
import RestroomsContent from './content/RestroomsContent';
import RestroomExpanded from './content/RestroomExpanded';

const Restrooms = ({ faqData = {}, expanded = false }) => {
  const { selectedRestrooms, notSelectedRestrooms } = restroomsSelected(faqData);
  if (expanded) {
    return (
      <>
        <RestroomExpanded
          faqData={faqData}
          selectedRestrooms={selectedRestrooms}
          notSelectedRestrooms={notSelectedRestrooms}
        />
      </>
    );
  }
  return (
    <>
      <RestroomsContent
        faqData={faqData}
        selectedRestrooms={selectedRestrooms}
        notSelectedRestrooms={notSelectedRestrooms}
      />
    </>
  );
};

Restrooms.propTypes = {
  faqData: PropTypes.object,
  intl: PropTypes.object,
  expanded: PropTypes.bool
};

export default Restrooms;
